import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import PageMeta from "../../components/PageMeta";
import ComponentComposer from "../../components/ComponentComposer";
import { fetchGiveaway, fetchGiveawayConfirm } from "../../api/cms";
import AnalyticsPageLoad from "../../components/AnalyticsPageLoad/AnalyticsPageLoad";
import {  Route } from "react-router-dom";


const GiveawaysPage: React.FC<any> = ({ confirm = false }) => {
  const [isLoaded, setIsLoaded] = useState(false);
  const [data, setData] = useState<any[]>([]);
  const [page, setPage] = useState<any>([]);
  const [ogMetaTags, setOgMetaTags] = useState<any>({});
  const [sitePageTitle, setPageTitle] =useState("wof");
  const [basicMetaTags, setBasicMetaTags] = useState<any>({});
  const [twitterMetaTags, setTwitterMetaTags] = useState<any>({});

  const { giveaway, type } = useParams();

  useEffect(() => {
    const fetchData = async () => {
      let urlParam = giveaway;
      if (type !== undefined && giveaway !== undefined) {
        urlParam = giveaway + "/" + type;
      }

      const fetchApi = confirm ? fetchGiveawayConfirm : fetchGiveaway;
      const _data = await fetchApi(urlParam);

      if (_data.error === true) {
        return;
      }
      setIsLoaded(true);
      if (_data.components){
        for(var i = 0; i < _data.components.length; i++) {
          _data.components[i].data.componentId = "component-position-" + i;
        }
      }
      setData(_data.components);
      setPage(_data.page);

      if (_data.page && _data.page.og_meta_tags && _data.page.og_meta_tags !== "") {
        setOgMetaTags(_data.page.og_meta_tags);
      }
      if (_data.page && _data.page.page_title && _data.page.page_title !== "") {
        setPageTitle(_data.page.page_title);
      }

      if (_data.page && _data.page.basic_meta_tags && _data.page.basic_meta_tags !== "") {
        setBasicMetaTags(_data.page.basic_meta_tags);
      }

      if (_data.page && _data.page.twitter_meta_tags && _data.page.twitter_meta_tags !== "") {
        setTwitterMetaTags(_data.page.twitter_meta_tags);
      }

      if (_data.page && _data.page.redirect) {
        window.location.replace(_data.page.redirect);
      }
    };

    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const pageTitle = (page && page.title) || giveaway;
  if (page.redirect_path) {
    let path = page.redirect_path;
    let _path =
      path.includes("https") || path.includes("http") || path.includes("www")
        ? path
        : window.location.origin + path;

    return (
      <Route
        to={_path}
        component={() => {
          window.location.href = _path;
          return null;
        }}
      />
    );
  } else {
    return (
      <div className={'wof-react-component remove-bg ' + page.page_class}>
        {isLoaded && <AnalyticsPageLoad contentTitle={pageTitle} />}
        <PageMeta 
        sitePageTitle={sitePageTitle} 
        ogMetaTags={ogMetaTags} 
        basicMetaTags={basicMetaTags} 
        twitterMetaTags={twitterMetaTags} />
        {data &&
          data.map((d, i) => (
            <ComponentComposer
              BodyBackgroundColor={
                page.BodyBackgroundColor ? page.BodyBackgroundColor : ""
              }
              bodyBackgroundDesktopImg={
                page.bodyBackgroundDesktopImg ? page.bodyBackgroundDesktopImg : ""
              }
              bodyBackgroundMobileImg={
                page.bodyBackgroundMobileImg ? page.bodyBackgroundMobileImg : ""
              }
              dyanmodb_table={page.dyanmodb_table ? page.dyanmodb_table : ""}
              key={i}
              {...d}
            />
          ))}
          
      </div>
    );
  }
};

export default GiveawaysPage;
